/**
 * `/team/leaves` route — gated on `leave:read:team` per be-063.
 * Renders the live <TeamLeavesScreen> list view (Phase 08.2, D-16).
 */
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { TeamLeavesScreen } from "../features/team/TeamLeavesScreen.js";

export const Route = createFileRoute("/_auth/team/leaves")({
  staticData: { breadcrumb: { labelKey: "team:nav.leaves" } },
  beforeLoad: requirePermission({
    anyOf: ["leave:read:team"],
    defaultRoute: "/me/overview",
  }),
  component: TeamLeavesScreen,
});
